import React from 'react';

const CadenceProblem = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
            Turn Practice Into <span className="text-cyan-400">Performance</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-2xl text-white font-semibold">
            High-performing teams don't improvise.
          </p>
          <p className="text-2xl text-cyan-400 font-semibold">
            They rehearse.
          </p>
          <p className="text-lg text-gray-400 mt-8 max-w-3xl mx-auto">
            Traain Cadence uses AI-driven role-play to help teams practice real conversations, build confidence, and improve execution — without relying on managers to coach every interaction.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CadenceProblem;
